/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, IntrinsicBox } from '@tishman/components';
import React from 'react';

interface PrintImageProps {
  src: string;
}

export const PrintImage = ({ src }: PrintImageProps): React.JSX.Element => {
  return (
    <Box
      sx={{
        'position': 'relative',
        'borderRight': ['none', null, 'dashed 1px #333'],
        'borderTop': ['none', null, 'dashed 1px #333'],
        'p': [2, 4, 6],
        '@media print': {
          py: 4,
          px: 5,
          pb: 0,
          m: 0,
        },
      }}
    >
      {src && <IntrinsicBox></IntrinsicBox>}
    </Box>
  );
};
